import { Button } from '@mui/material';
import { alpha } from '@mui/material/styles';
import React from 'react';

// The AI affordance reads as its own thing (violet, borderless) so it never competes
// with Ack for the primary action. Rendered only when the chat drawer is enabled.
function AskAiButton({
  label = 'Ask AI',
  onClick,
  testId,
  fullWidth = false,
}: {
  label?: string;
  onClick: () => void;
  testId: string;
  fullWidth?: boolean;
}) {
  return (
    <Button
      size="small"
      fullWidth={fullWidth}
      data-testid={testId}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      sx={{
        flex: fullWidth ? 1 : 'none',
        whiteSpace: 'nowrap',
        textTransform: 'none',
        fontWeight: 550,
        color: 'secondary.dark',
        bgcolor: (t) => alpha(t.palette.secondary.main, 0.1),
        '&:hover': { bgcolor: (t) => alpha(t.palette.secondary.main, 0.18) },
      }}
    >
      {`✦ ${label}`}
    </Button>
  );
}

export default AskAiButton;
